import { useOpenClose } from '@css-xp/ppc-custom-hooks';
import React, { useCallback, useState } from 'react';
import Popup from '@atlaskit/popup';
import Button from '@atlaskit/button';
import MoreIcon from '@atlaskit/icon/glyph/more';
import { ContactType, DeleteContact } from '@css-xp/base';

interface Props {
  invoiceContact: string;
  isLoading: boolean;
  handleInvoiceContactsDeletion: (contact: string, closeModal: () => void) => void;
}

export const InvoiceContactsMoreActions = ({
  invoiceContact,
  handleInvoiceContactsDeletion,
  isLoading,
}: {
  invoiceContact: string;
  isLoading: boolean;
  handleInvoiceContactsDeletion: (contact: string, closeModal: () => void) => void;
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const {
    isOpen: showInvoiceContactsModal,
    open: openInvoiceContactModal,
    close: closeInvoiceContactModal,
  } = useOpenClose();

  const renderDeleteInvoiceContacts = useCallback(
    (
      showInvoiceContactsModal: boolean,
      openInvoiceContactModal: () => void,
      closeInvoiceContactModal: () => void,
      contact: string
    ) => {
      return (
        <DeleteContact
          isModalOpen={showInvoiceContactsModal}
          openModal={openInvoiceContactModal}
          closeModal={closeInvoiceContactModal}
          onDeleteConfirm={handleInvoiceContactsDeletion}
          contact={contact}
          contactType={ContactType.INVOICE_CONTACT}
          isLoading={isLoading}
        />
      );
    },
    [isLoading]
  );

  return (
    <Popup
      testId="invoice-contact-action"
      isOpen={isOpen}
      content={() =>
        renderDeleteInvoiceContacts(
          showInvoiceContactsModal,
          openInvoiceContactModal,
          closeInvoiceContactModal,
          invoiceContact
        )
      }
      placement={'bottom-end'}
      /* if popup gets close then automatically modal will also get close,
      because Modal is wrapped inside Popup */
      onClose={() => !showInvoiceContactsModal && setIsOpen(false)}
      trigger={(triggerProps) => (
        <Button
          {...triggerProps}
          isSelected={isOpen}
          onClick={() => setIsOpen(!isOpen)}
          iconBefore={<MoreIcon label="More" />}
          testId="invoice-contact-action-trigger"
          appearance="subtle"
        />
      )}
    />
  );
};
